import {applyInteractionId, mark, getInteractionId, types as metrics} from '@servicenow/ui-metrics';
import getStatePropsContext from './getStatePropsContext';
import deferHelperExecution from './deferHelperExecution';
import {
	SCHEDULE_IMMEDIATELY_DO_NOT_USE_OR_YOU_WILL_BE_IMMEDIATELY_FIRED,
	HELPERS_SCHEDULED,
	HELPERS_DEFER
} from '../../constants';
import {normalizeActionMeta} from '../normalizeActionMeta';

const wrapDispatch = (host, shouldWrap) => {
	if (shouldWrap === HELPERS_SCHEDULED) return host.dispatch;

	return function dispatch(type, payload, meta = {}, error) {
		meta[SCHEDULE_IMMEDIATELY_DO_NOT_USE_OR_YOU_WILL_BE_IMMEDIATELY_FIRED] = true; // eslint-disable-line no-param-reassign
		return host.dispatch(type, payload, meta, error);
	};
};

export default function createDispatch(host, executionTiming) {
	return function dispatch(typeOrFn, payload, meta = {}, error) {
		// eslint-disable-next-line no-param-reassign
		meta = normalizeActionMeta(meta, {host});
		const interactionId = getInteractionId(meta);
		if (executionTiming === HELPERS_DEFER)
			mark(host, interactionId, metrics.DEFER, {deferred: metrics.DISPATCH, type: typeOrFn});

		deferHelperExecution(
			executionTiming,
			() => {
				const wrappedDispatch = wrapDispatch(host, executionTiming);
				if (typeof typeOrFn === 'function') {
					const statePropsContext = getStatePropsContext(host, interactionId);
					const {
						type,
						payload,
						meta = {},
						error,
						shouldDispatch = true
					} = typeOrFn(statePropsContext);
					if (shouldDispatch) {
						applyInteractionId(meta);
						wrappedDispatch(type, payload, meta, error);
					}
				} else {
					applyInteractionId(meta);
					wrappedDispatch(typeOrFn, payload, meta, error);
				}
			},
			{...meta, el: host, interactionId}
		);
	};
}
